module.exports = __webpack_public_path__ + "media/init/static/fonts/GT-Eesti-Pro-Display-Bold-46a76a01e77dab0178e164dbb4da523d.OTF";